import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface UnsavedChangesDialogProps {
	open: boolean;
	/** Keep editing. */
	onStay: () => void;
	/** Throw the changes away and continue (leave the page, close the form). */
	onDiscard: () => void;
	title?: string;
	description?: string;
	discardLabel?: string;
}

/**
 * Confirmation shown when unsaved changes would be lost. Plain buttons (not
 * `AlertDialogAction`/`AlertDialogCancel`) so closing never skips Radix's
 * modal cleanup, like the other confirm dialogs.
 */
export function UnsavedChangesDialog({
	open,
	onStay,
	onDiscard,
	title = 'Discard unsaved changes?',
	description = 'You have changes that are not saved. If you continue, they will be lost.',
	discardLabel = 'Discard changes',
}: UnsavedChangesDialogProps) {
	return (
		<AlertDialog
			open={open}
			onOpenChange={(next) => {
				if (!next) onStay();
			}}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{title}</AlertDialogTitle>
					<AlertDialogDescription>{description}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<Button type="button" variant="outline" onClick={onStay} autoFocus>
						Keep editing
					</Button>
					<Button type="button" variant="destructive" onClick={onDiscard}>
						{discardLabel}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
